import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

const unsubscribers = []

onDomLoad(function ($dom) {
  const deleteButton = $dom[0].querySelector(
    '[data-behavior="account-delete-reconciliation"]'
  )

  if (!deleteButton) return

  unsubscribers.forEach((callback) => {
    callback()
  })

  deleteButton.addEventListener('click', handleClick)

  unsubscribers.push(() => {
    deleteButton.removeEventListener('click', handleClick)
  })
})

function handleClick(event) {
  event.preventDefault()

  const deleteButton = event.target

  // The unreview confirmation modal only hides the other modals,
  // that's why we need to remove the RemoveConfirmModal manually to be able to show it again.
  // We need this when the user closes the unreview confirmation modal without confirming it
  // and then tries to delete the reconciliation again.
  removePreviousSfRemoveConfirmModal()

  window.sfRemoveConfirm({
    name: I18n.t('account_entry.reconciliation'),
    message: deleteButton.dataset.message,
    keep: true,
    onConfirm: () => {
      deleteReconciliationWithUnreviewConfirmation(deleteButton.dataset.url)
    },
  })
}

// This happens when the user closes the unreview confirmation modal without confirming
// and then tries to delete the reconciliation again
function removePreviousSfRemoveConfirmModal() {
  const modal = document.querySelector(
    '[data-behaviour="global-confirmation-modal"].hidden'
  )
  if (modal) {
    modal.remove()
  }
}

function deleteReconciliationWithUnreviewConfirmation(url) {
  window.eventHub.$emit('confirmUnreviewTemplate', {
    keepOpenAfterConfirmation: true,
    callback: () => {
      performDelete(url)
    },
  })
}

async function performDelete(url) {
  try {
    const response = await SFetch.json(url, { method: 'DELETE' })

    window.Silverfin.Polling.subscribeAndReloadWhenMatching(
      response.channel,
      response.lastId,
      response.context
    )
  } catch (e) {
    SfLog.warn('Error during deleting reconciliation', {
      extra: {
        error: e,
      },
    })
  }
}
